// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"9b0ef25c","885":"aa4aa143"}[chunkId] + ".chunk.js";
};